module.exports = __webpack_public_path__ + "ceb75f6ea7b524dd74ea9dfbd5d6dd20.svg";